import { Model } from 'sunlife-domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const chooseFirstDesignOnCollectionChange = configuratorInterface.transformerBuilder.when
  .entity(Model.WithDesign.types)
  .modified({ atFields: ['collection'] })
  .then.applySideEffect(ctx => {
    const entity = ctx.getNew$Entity()
    const collection = entity.$collectionMap[entity.collection]
    const design = Object.values(collection?.designs ?? { key: 'default' })[0]?.key ?? 'default'
    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId: entity.id,
        stateDelta: {
          design,
        },
        updateTag: 'chooseFirstDesignOnCollectionChange',
      }),
    ]
  })
  .build('chooseFirstDesignOnCollectionChange')
